export default "__VITE_ASSET__4e1ebeeb__"